import { render, staticRenderFns } from "./SerialDialog.vue?vue&type=template&id=92dc7386&scoped=true"
import script from "./SerialDialog.vue?vue&type=script&lang=js"
export * from "./SerialDialog.vue?vue&type=script&lang=js"
import style0 from "./SerialDialog.vue?vue&type=style&index=0&id=92dc7386&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dc7386",
  null
  
)

export default component.exports